"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = exports.TabContent = exports.Description = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
const Button_1 = require("../../Button");
const Grid_1 = require("../../Grid");
exports.Wrap = (0, app_1.styled)(Grid_1.Grid) `
  width: 100%;
  grid-template-rows: calc(${(theme) => theme.spacing.extraLarge} * 1.5) calc(
      ${(theme) => theme.spacing.large} * 1.5
    );
`;
exports.Description = (0, app_1.styled)(app_1.Text) `
  width: 60%;
  margin: 0 auto;
  @media ${app_1.notDesktop} {
    display: none;
  }
`;
exports.TabContent = (0, app_1.styled)(Button_1.Button) `
  background-color: ${(theme, { $active }) => $active ? theme.colors.additional[2] : theme.colors.gray};
  color: ${(theme, { $active }) => $active ? theme.colors.primary : theme.colors.additional[1]};
  padding: ${(theme) => theme.spacing.medium} 0;
  height: auto !important;
  position: relative;
  grid-row: 2;
  > div {
    color: ${(theme, { $active }) => $active ? theme.background : theme.colors.additional[1]};
  }
`;
exports.Badge = app_1.styled.div `
  --badge-size: 1.5rem;
  position: absolute;
  ${(theme) => theme.flexCenter};
  top: calc(var(--badge-size) / 2 * -1);
  width: var(--badge-size);
  height: var(--badge-size);
  border-radius: 9999px;
  background-color: ${(theme, { $active }) => $active ? theme.colors.primary : theme.colors.additional[3]};

  color: ${(theme, { $active }) => $active ? 'white' : theme.colors.additional[1]}tn;
`;
